import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent } from './map.component';
import { SideBarModule } from './side-bar/side-bar.module';
import { MatInputModule } from '@angular/material';
import { ResultModule } from './result/result.module';
import { LayoutModule } from '../../layout/layout.module';
import { SliderModule } from './slider/slider.module';



@NgModule({
  declarations: [MapComponent],
  imports: [
    CommonModule,
    SideBarModule,
    MatInputModule,
    ResultModule,
    LayoutModule,
    SliderModule
  ]
})
export class MapModule { }
